import React, { Component } from "react";

import VeranstaltungServiceInstance from "../services/VeranstaltungService";

import { Link } from 'react-router-dom';
import CenteredLoader from "./CenteredLoader";

export default class Veranstaltungen extends Component {
    constructor(props) {
        super(props);
        this.state = { liste: null };
    }

    componentDidMount() {
        VeranstaltungServiceInstance.getAllUpcomingEvents().then(alle => {
            this.setState({ liste: alle });
        }).catch(err => console.log("fehler", err));
    }

    render() {
        const liste = (this.state.liste || []).map((event, idx) => (
            <tr key={idx}>
                <td><Link style={{ color: "#014c72" }} to={"/veranstaltungen/" + event.id}>{event.name}</Link>
                    <br />
                    <span className="jh-td-subtext">{event.veranstalter}</span>
                </td>
                <td className="d-none d-md-table-cell">{event.wettbewerbe.map((w) => w.bezeichnung).join(", ")}</td>
                <td>{event.datum}</td>
            </tr>
        ));

        const tabelle = (<div>
            <p>Ihr fühlt euch gut und habt Lust euch mit anderen zu messen? Hier sind die nächsten Veranstaltungen, bei denen ihr euch austoben könnt:</p>
            <table className="table table-hover table-responsive-sm">
                <thead>
                    <tr>
                        <th scope="col">Name der Veranstaltung</th>
                        <th scope="col" className="d-none d-md-table-cell">Sportart(en)</th>
                        <th scope="col">Datum</th>
                    </tr>
                </thead>
                <tbody>
                    {liste}
                </tbody>
            </table>
        </div>);

        return (
            <div className="row" >
                <div className="col-md-12 jh-content">
                    <h1>Anstehende Veranstaltungen</h1>
                    <CenteredLoader isVisible={!this.state.liste} text="Veranstaltungen werden geladen..."/>
                    {this.state.liste && tabelle}
                </div>
            </div>);
    }
};


// WEBPACK FOOTER //
// ./src/components/Veranstaltungen.js